//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "test",
  data() {
    return {
      //list_item: this.$route.query.list_item,
      wkt_login_peo: {
        id: "",
        name: "",
        class_id: ""
      },
      sum: 0, //总分
      value: "",
      list_ary: [], // 创建一个空的数组
      dataModel: [],
      title_ary: [],
      formLabelWidth: "120px",
      loading: false,
      confirm_up_title: "确认提交",
      confirm_up: false,
      toast_text: "",
      toast_show: false
    };
  },
  mounted() {
    this.loadMore();
    if (localStorage.getItem("wkt_login_peo")) {
      this.wkt_login_peo = JSON.parse(localStorage.getItem("wkt_login_peo"));
    } else {
      this.toast_value = "请登录";
      this.show_toast = true;
      let timer = setTimeout(() => {
        this.$router.push({
          path: "/my"
        });
      }, 800);
    }
  },
  components: {},
  methods: {
    loadMore: function() {
      let formData = new FormData();
      formData.append("action_type", "search_exam_question");
      formData.append("limit", 10);
      this.$http({
        url: "/search/common.php",
        method: "post",
        data: formData
      }).then(res => {
        let item_ary = [];
          let obj = {};
          //生成对应的value值
          for (let i = 0; i < res.data.length; i++) {
            let name = "value" + Math.random();
            item_ary.push(name);
          }
          //生成对象  key -> value
          for (let i = 0; i < res.data.length; i++) {
            obj[item_ary[i]] = "";
          }

          for (let i in obj) {
            let o = {};
            o[i] = obj[i];
            this.dataModel.push(o);
          }
          //生成数组  里面是对象
          this.list_ary = res.data;
          this.loading = false;
      });

    },
    check: function(title, answer, choice, seq) {
      if (this.title_ary[seq] == undefined) {
        //第一次答题

        if (answer == choice) {
          let arrStr = {
            title: 1
          };
          this.title_ary.push(arrStr);
          this.sum += 10;
          this.print(this.sum, this.title_ary);
        } else {
          let arrStr = {
            title: 0
          };
          this.title_ary.push(arrStr);
          this.print(this.sum, this.title_ary);
        }
      } else {
        if (this.title_ary[seq].title == 1) {
          //上一次已经回答正确
          if (answer == choice) {
            this.print(this.sum, this.title_ary);
          } else {
            this.sum -= 10;
            this.title_ary[seq].title = 0;
            this.print(this.sum, this.title_ary);
          }
        } else {
          //上一次已经回答错误
          if (answer == choice) {
            this.title_ary[seq].title = 1;
            this.sum += 10;
            this.print(this.sum, this.title_ary);
          } else {
            this.title_ary[seq].title = 0;
            this.print(this.sum, this.title_ary);
          }
        }
      }
    },

    onConfirm() {
      this.loading = true;
      let formData = new FormData();
      formData.append("action_type", "stu_test_marks");
      formData.append("stu_id", this.wkt_login_peo.stu_id);
      formData.append("stu_name", this.wkt_login_peo.stu_name);
      formData.append("class_id", this.wkt_login_peo.class_id);
      formData.append("class_name", this.wkt_login_peo.class_name);
      formData.append("sum", this.sum);

      this.$http({
        url: "upload/common.php",
        method: "post",
        data: formData,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(res => {
          this.loading = false;
          if (res.data.status == 1) {
            this.toast_text = "分数" + this.sum;
            this.toast_show = true;
            let item = {
              type: 1
            };
            let timer = setTimeout(function() {
              this.$router.push({
                path: "/home_page_next",
                query: item
              });
              clearInterval(timer);
            }, 800);
          } else {
            this.toast_value = "上传失败";
            this.show_toast = true;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    onCancel() {},
    print(sum, title_ary) {
      console.log("总分:" + this.sum);
      console.log("正确错误" + this.title_ary[0].title);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/test.vue